module.exports = __webpack_public_path__ + "static/media/IMG_2346.253af508.jpg";